import React from 'react'

export const Tab = (props) => {
    return (
        <React.Fragment>
            {props.children}
        </React.Fragment>
    );
}

